import * as React from "react";
import { Grid } from "../../grid/grid/grid.mjs";
import { GridColumn } from "../../grid/grid-column/grid-column.mjs";
import { OfferCounterItem } from "../offer-counter-item/offer-counter-item.mjs";
const _OfferCounter = class _OfferCounter extends React.Component {
  constructor() {
    super(...arguments);
    this.getEdgeClass = (index) => {
      const { itemsPerRowLg } = this.props;
      if (index % itemsPerRowLg === 0) {
        return "offer-counter__item--edge-start";
      } else if ((index + 1) % itemsPerRowLg === 0) {
        return "offer-counter__item--edge-end";
      }
    };
  }
  getItems() {
    const { itemsPerRowLg, itemsPerRowMd, itemsPerRowSm, itemsPerRowXs } = this.props;
    const colWidthLg = 12 / itemsPerRowLg;
    const colWidthMd = 12 / itemsPerRowMd;
    const colWidthSm = 12 / itemsPerRowSm;
    const colWidthXs = 12 / itemsPerRowXs;
    const itemWidth = [
      "lg-".concat(colWidthLg),
      "md-".concat(colWidthMd),
      "sm-".concat(colWidthSm),
      "xs-".concat(colWidthXs)
    ];
    let extraKey;
    const childArray = React.Children.toArray(this.props.children).filter((child) => {
      return React.isValidElement(child) && child.type === OfferCounterItem;
    }).map((child, i) => {
      const cloneProps = {
        className: this.getEdgeClass(i),
        key: i,
        width: itemWidth
      };
      extraKey = i + 1;
      return React.cloneElement(child, cloneProps);
    });
    const itemsOnLastRowLg = childArray.length % itemsPerRowLg;
    const itemsOnLastRowMd = childArray.length % itemsPerRowMd;
    const itemsOnLastRowSm = childArray.length % itemsPerRowSm;
    const itemsOnLastRowXs = childArray.length % itemsPerRowXs;
    if (itemsOnLastRowLg !== 0 || itemsOnLastRowMd !== 0 || itemsOnLastRowSm !== 0 || itemsOnLastRowXs !== 0) {
      const itemsToFillRowLg = itemsPerRowLg - itemsOnLastRowLg;
      const itemsToFillRowMd = itemsPerRowMd - itemsOnLastRowMd;
      const itemsToFillRowSm = itemsPerRowSm - itemsOnLastRowSm;
      const itemsToFillRowXs = itemsPerRowXs - itemsOnLastRowXs;
      const extraItemClasses = ["offer-counter__item--edge-end"];
      const extraItemWidth = [
        "lg-".concat(itemsToFillRowLg * colWidthLg),
        "md-".concat(itemsToFillRowMd * colWidthMd),
        "sm-".concat(itemsToFillRowSm * colWidthSm),
        "xs-".concat(itemsToFillRowXs * colWidthXs)
      ];
      if (itemsToFillRowLg === itemsPerRowLg) {
        extraItemClasses.push("hidden-lg hidden-xl");
      }
      if (itemsToFillRowMd === itemsPerRowMd) {
        extraItemClasses.push("hidden-md");
      }
      if (itemsToFillRowSm === itemsPerRowSm) {
        extraItemClasses.push("hidden-sm");
      }
      if (itemsToFillRowXs === itemsPerRowXs) {
        extraItemClasses.push("hidden-xs");
      }
      childArray.push(/* @__PURE__ */ React.createElement(OfferCounterItem, { key: extraKey, className: extraItemClasses.join(" "), width: extraItemWidth }));
    }
    return childArray;
  }
  BEM() {
    const classArray = ["offer-counter"];
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  render() {
    return /* @__PURE__ */ React.createElement(Grid, { align: ["center-xs"], className: this.BEM() }, /* @__PURE__ */ React.createElement(GridColumn, { width: ["lg-10", "md-12"] }, /* @__PURE__ */ React.createElement(Grid, { verticalGutter: "none" }, this.getItems())));
  }
};
_OfferCounter.defaultProps = {
  itemsPerRowLg: 6,
  itemsPerRowMd: 4,
  itemsPerRowSm: 3,
  itemsPerRowXs: 2
};
let OfferCounter = _OfferCounter;
export {
  OfferCounter
};
